import { Role } from "@/core/administration/entities/Roles";

export interface ApiRoleItem {
  id: string;
  name: string;
  nbrAssignation: number;
  criticite: string;
  statut: string;
  // permissions: string[];
}

export default class RolesMapper {
  static toDomain(item: ApiRoleItem): Role {
    return {
      id: item.id,
      name: item.name,
      assignations: item.nbrAssignation,
      criticite: item.criticite,
      statut: item.statut,
      // permissions: item.permissions,
    };
  }

  static toDomainItems(items: ApiRoleItem[]): Role[] {
    return items.map((item) => RolesMapper.toDomain(item));
  }
}